import type { Criteria } from 'bundles/connect/types';
import type { RootState } from '../root_reducer';

export const selectMapBounds = (state: RootState) => state.criteria.mapBounds;

export const selectCriteria = (state: RootState): Criteria => state.criteria;

export const selectLocationAttributes = (state: RootState) => state.criteria.locationsAttributes || [];
